export interface IColumn {
  Header: string;
  accessor: string;
  width: number
}

const columns = [
  {
    Header: 'Type',
    accessor: 'type',
    width: 120,
  },
  {
    Header: 'Date',
    accessor: 'date',
    width: 140,
  },
  {
    Header: 'Narration',
    accessor: 'narration',
    width: 360,
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    width: 130,
  },
];

export default columns;
